<h2 mat-dialog-title class="dialog-header">
  <div class="dialog-title-block">
    <span class="dialog-overline">{{'refund.details.title'|traduccion}}</span>
    <div class="dialog-title-row">
      <div>
        <div class="dialog-title">{{ refund.uuid }}</div>
        <div class="dialog-subtitle">Detalle del reembolso, ticket emitido e invoice si existe.</div>
      </div>
      <span class="status-pill" [ngClass]="refund.status?.toLowerCase()">{{ refund.status|traduccion }}</span>
    </div>
  </div>

  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content">
  <div class="info-grid" appGridColumns [colsLg]="2" [colsMd]="2" [colsSm]="1" [colWidths]="[50, 50]">
    <mat-card class="detail-card accent-card">
      <div class="card-heading">
        <h3>{{'refund.details.payment'|traduccion}}</h3>
        <mat-icon>undo</mat-icon>
      </div>

      <div class="detail-list">
        <div class="detail-item">
          <span class="detail-label">{{'refund.details.createdAt'|traduccion}}</span>
          <strong>{{ refund.createdAt | date: appService.FORMAT_DATETIME }}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'refund.details.basePrice'|traduccion}}</span>
          <strong>{{ refund.basePrice|currency }} {{diff?.basePrice ? '('+diff?.basePrice.kiosk+')' : ''}}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'refund.details.tax'|traduccion}}</span>
          <strong>{{ refund.taxPrice|currency }} {{diff?.taxPrice ? '('+diff?.taxPrice.kiosk+')' : ''}} ({{ refund.tax * 100 }} {{diff?.tax ? '('+diff?.tax.kiosk+')' : ''}}%)</strong>
        </div>
        <div class="detail-item total-item">
          <span class="detail-label">{{'refund.details.totalPrice'|traduccion}}</span>
          <strong>{{ refund.totalPrice|currency }} {{diff?.totalPrice ? '('+diff?.totalPrice.kiosk+')' : ''}}</strong>
        </div>
      </div>
    </mat-card>
  </div>

  <div class="info-grid" appGridColumns [colsLg]="2" [colsMd]="2" [colsSm]="1" [colWidths]="[50, 50]">
    <mat-card class="detail-card">
      <div class="card-heading">
        <h3>{{'refund.details.ticket'|traduccion}} {{ refund.dataTicket.ticketNumber }}</h3>
        <mat-icon>receipt_long</mat-icon>
      </div>

      <div class="detail-list">
        <div class="detail-item">
          <span class="detail-label">{{'refund.details.ticket.date'|traduccion}}</span>
          <strong>{{ refund.dataTicket.date }}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'refund.details.ticket.type'|traduccion}}</span>
          <strong>{{ refund.dataTicket.type }}</strong>
        </div>
        <div class="detail-item total-item">
          <span class="detail-label">{{'refund.details.ticket.total'|traduccion}}</span>
          <strong>{{refund.dataTicket.totalPriceWithTax|currency}}</strong>
        </div>
      </div>

      <div class="list-block">
        <span class="detail-label">{{'refund.details.ticket.products'|traduccion}}</span>
        <ul>
          <li *ngFor="let product of refund.dataTicket.products">{{product.name}}</li>
        </ul>
      </div>

      <div class="action-row">
        <button mat-stroked-button (click)="downloadTicket()"><mat-icon>download</mat-icon>{{'refund.details.ticket.download'|traduccion}}</button>
        <button mat-stroked-button *appShowForRoles="['ROLE_ADMIN']" (click)="generateTicket()"><mat-icon>confirmation_number</mat-icon>{{'refund.details.ticket.generate'|traduccion}}</button>
        <button mat-button *appShowForRoles="['ROLE_ADMIN']" (click)="openDialogTicketRawData()">{{'refund.details.ticket.rawData'|traduccion}}</button>
      </div>
    </mat-card>

    <mat-card *ngIf="refund.invoice" class="detail-card">
      <div class="card-heading">
        <h3>{{'invoice'|traduccion}} {{ refund.invoice?.invoiceNumber }}</h3>
        <mat-icon>description</mat-icon>
      </div>

      <div class="detail-list">
        <div class="detail-item">
          <span class="detail-label">{{'invoice.createdAt'|traduccion}}</span>
          <strong>{{ refund.invoice?.createdAt | date: appService.FORMAT_DATETIME }}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'invoice.status'|traduccion}}</span>
          <strong>{{ refund.invoice?.status }}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'invoice.addressClient'|traduccion}}</span>
          <strong>{{ refund.invoice?.addressClient }}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'invoice.companyNameClient'|traduccion}}</span>
          <strong>{{ refund.invoice?.companyNameClient }}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'invoice.emailClient'|traduccion}}</span>
          <strong>{{ refund.invoice?.emailClient }}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'invoice.idClient'|traduccion}}</span>
          <strong>{{ refund.invoice?.typeIdClient }} {{ refund.invoice?.idClient }}</strong>
        </div>
      </div>

      <div class="action-row">
        <button mat-stroked-button (click)="downloadFactura()"><mat-icon>download</mat-icon>{{'invoice.download'|traduccion}}</button>
      </div>
    </mat-card>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer"></mat-dialog-actions>
